import type {AccountInfo} from '@azure/msal-browser';
import type {Subscription} from 'rxjs';

export abstract class BdUserTracker {

  public isEnabled: boolean;

  protected _subs: Subscription[] = [];

  public abstract name: string;

  public abstract init(accountInfo: AccountInfo | null): void;

  public abstract destroy(): void;

  public abstract addAuthenticatedUserContext(accountInfo: AccountInfo): void;

  public abstract removeAuthenticatedUserContext(): void;

  public abstract trackException(error: any, customProperties?: {[key: string]: any}): void;

  public abstract trackEvent(event: string, customProperties?: {[key: string]: any}): void;

  protected _unsubscribe(): void {
    this._subs.forEach(sub => sub.unsubscribe());
    this._subs = [];
  }
}
